import { css } from "styled-components";

export const clickable = css`
  cursor: pointer;
  user-select: none;
`;